import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { Observable } from "rxjs";
import { database } from "firebase";
import { map, tap } from "rxjs/operators";
import { LotePresupuesto } from "../models/entities/lote-presupuesto";

@Injectable({
  providedIn: "root",
})
export class ReportePresupuestoService {
  public path: string;

  public constructor(public angularFireDatabase: AngularFireDatabase) {
    this.path = "lotesPresupuestos";
  }

  /** Metodo utilizado para obtener la informacion de los presupestos por la cve del estado */
  public findByAnioPef(cveEstado: string): Observable<LotePresupuesto[]> {
    return this.angularFireDatabase
      .list<LotePresupuesto>(
        this.path,
        (ref: database.Reference) => ref.orderByChild("anio").equalTo(2021) //Remplazar año con año para visualizar presupuesto "lotesPresupuestos"
      )
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as LotePresupuesto)
          )
        )
      );
  }
}
